module.exports = __webpack_public_path__ + "img/user112.6e538094.jpg";